import React from 'react'
import cn from "classnames";
import styles from "./Forms.module.sass";
import { useWeb3App } from "../../../core/appContext";


export function InviteReward({ balances }) {
    const ghApp = useWeb3App()

    let { link } = React.useMemo(() => {
        const account = ghApp?.account
        const isValid = account ? ghApp.web3.utils.isAddress(account) : null

        if (balances?.myStakedCNR < 100 || !isValid) return {
            link: null,
            account
        }

        const { origin, pathname } = window.location

        const link = `${origin}${pathname}?reff=${account}`
        return {
            link,
            account
        }
    }, [ghApp, balances])

    return (
        <div className={cn(styles.invite_reward)}>
            <div>
                <div className={styles.ref_title}>Total Invite Rewards</div>
                <div className={styles.lastProp}>
                    <span className={styles.amount_amount}>{balances?.myInviteRewards}</span>
                    <span className={styles.amount_cur}> CNR</span>
                </div>
                <div className={styles.ref_body}>
                    <div className={styles.ref_desc}>Use the below link to invite your friends and earn 0.5% of their stake</div>
                    <div>
                        <a className={cn(styles.ref_link, {[styles.disable]: !link})} href={link}>{link}</a>
                    </div>
                </div>
            </div>
            {!link && <div className={cn(styles.ref_footer)}>You need to have 100 CNR minimum staked to activate your referral link</div>}
        </div>
    )
}
